var cov_1d96yl9tmk = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Image/Group.tsx",
      hash = "9886ee2b4327d078fad9924b5a03a42c748b9e4e",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Image/Group.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 25
        },
        end: {
          line: 11,
          column: 35
        }
      },
      "1": {
        start: {
          line: 12,
          column: 25
        },
        end: {
          line: 12,
          column: 27
        }
      },
      "2": {
        start: {
          line: 13,
          column: 18
        },
        end: {
          line: 13,
          column: 19
        }
      },
      "3": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 20,
          column: 6
        }
      },
      "4": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 19,
          column: 7
        }
      },
      "5": {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 48
        }
      },
      "6": {
        start: {
          line: 16,
          column: 25
        },
        end: {
          line: 16,
          column: 48
        }
      },
      "7": {
        start: {
          line: 17,
          column: 30
        },
        end: {
          line: 17,
          column: 41
        }
      },
      "8": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 61
        }
      },
      "9": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 32
        }
      },
      "10": {
        start: {
          line: 26,
          column: 48
        },
        end: {
          line: 26,
          column: 58
        }
      },
      "11": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 36,
          column: 5
        }
      },
      "12": {
        start: {
          line: 30,
          column: 10
        },
        end: {
          line: 33,
          column: 12
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 29
          },
          end: {
            line: 23,
            column: 3
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 39
          },
          end: {
            line: 14,
            column: 40
          }
        },
        loc: {
          start: {
            line: 14,
            column: 110
          },
          end: {
            line: 20,
            column: 5
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 3
          }
        },
        loc: {
          start: {
            line: 25,
            column: 11
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 29,
            column: 51
          },
          end: {
            line: 29,
            column: 52
          }
        },
        loc: {
          start: {
            line: 30,
            column: 10
          },
          end: {
            line: 33,
            column: 12
          }
        },
        line: 30
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        }, {
          start: {
            line: 15,
            column: 6
          },
          end: {
            line: 19,
            column: 7
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 15,
            column: 10
          },
          end: {
            line: 15,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 15,
            column: 10
          },
          end: {
            line: 15,
            column: 15
          }
        }, {
          start: {
            line: 15,
            column: 19
          },
          end: {
            line: 15,
            column: 29
          }
        }, {
          start: {
            line: 15,
            column: 33
          },
          end: {
            line: 15,
            column: 64
          }
        }],
        line: 15
      },
      "2": {
        loc: {
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 16,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 16,
            column: 48
          }
        }, {
          start: {
            line: 16,
            column: 8
          },
          end: {
            line: 16,
            column: 48
          }
        }],
        line: 16
      },
      "3": {
        loc: {
          start: {
            line: 18,
            column: 39
          },
          end: {
            line: 18,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 39
          },
          end: {
            line: 18,
            column: 43
          }
        }, {
          start: {
            line: 18,
            column: 47
          },
          end: {
            line: 18,
            column: 50
          }
        }],
        line: 18
      },
      "4": {
        loc: {
          start: {
            line: 28,
            column: 42
          },
          end: {
            line: 28,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 42
          },
          end: {
            line: 28,
            column: 46
          }
        }, {
          start: {
            line: 28,
            column: 50
          },
          end: {
            line: 28,
            column: 56
          }
        }],
        line: 28
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Image/Group.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent, Children, cloneElement } from 'react';
import showGallery from './events';
import { IMAGE } from './Image';
import { imageClass } from './styles';

var Group =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Group, _PureComponent);

  var _super = _createSuper2(Group);

  function Group() {
    _classCallCheck(this, Group);

    return _super.apply(this, arguments);
  }

  _createClass(Group, [{
    key: "handleClick",
    value: function handleClick(index) {
      cov_1d96yl9tmk.f[0]++;

      var _ref = (cov_1d96yl9tmk.s[0]++, this.props),
          children = _ref.children;

      var images = (cov_1d96yl9tmk.s[1]++, []);
      var current = (cov_1d96yl9tmk.s[2]++, 0);
      cov_1d96yl9tmk.s[3]++;
      Children.toArray(children).forEach(function (child, i) {
        cov_1d96yl9tmk.f[1]++;
        cov_1d96yl9tmk.s[4]++;

        if ((cov_1d96yl9tmk.b[1][0]++, child) && (cov_1d96yl9tmk.b[1][1]++, child.type) && (cov_1d96yl9tmk.b[1][2]++, child.type.symbolType === IMAGE)) {
          cov_1d96yl9tmk.b[0][0]++;
          cov_1d96yl9tmk.s[5]++;

          if (index === i) {
            cov_1d96yl9tmk.b[2][0]++;
            cov_1d96yl9tmk.s[6]++;
            current = images.length;
          } else {
            cov_1d96yl9tmk.b[2][1]++;
          }

          var _ref2 = (cov_1d96yl9tmk.s[7]++, child.props),
              src = _ref2.src,
              href = _ref2.href;

          cov_1d96yl9tmk.s[8]++;
          images.push({
            thumb: src,
            src: (cov_1d96yl9tmk.b[3][0]++, href) || (cov_1d96yl9tmk.b[3][1]++, src),
            key: i
          });
        } else {
          cov_1d96yl9tmk.b[0][1]++;
        }
      });
      cov_1d96yl9tmk.s[9]++;
      showGallery(images, current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      cov_1d96yl9tmk.f[2]++;

      var _ref3 = (cov_1d96yl9tmk.s[10]++, this.props),
          children = _ref3.children,
          pile = _ref3.pile,
          style = _ref3.style,
          props = _objectWithoutProperties(_ref3, ["children", "pile", "style"]);

      cov_1d96yl9tmk.s[11]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: imageClass('group', (cov_1d96yl9tmk.b[4][0]++, pile) && (cov_1d96yl9tmk.b[4][1]++, 'pile')),
          style: style,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 28,
            columnNumber: 7
          }
        }, Children.toArray(this.props.children).map(function (child, i) {
          cov_1d96yl9tmk.f[3]++;
          cov_1d96yl9tmk.s[12]++;
          return (
            /*#__PURE__*/
            cloneElement(child, _objectSpread2(_objectSpread2({}, props), {}, {
              onClick: _this.handleClick.bind(_this, i)
            }))
          );
        }))
      );
    }
  }]);

  return Group;
}(PureComponent);

Group.displayName = void 0;
export default Group;